import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { ManagementUserService } from '../../shared/services/api/management-user.service';
import { SweetalertService } from '../../shared/services/sweetalert.service';

export const appAccountGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const managementUserService = inject(ManagementUserService);
  const sweetalertService = inject(SweetalertService);

  return managementUserService.getManagementUserAccount().pipe(
    map((response) => {
      const hasAppAccount = response != null;

      if (hasAppAccount) {
        return true;
      } else {
        return router.createUrlTree(['/createAccount']);
      }
    }),
    catchError((error) => {
      console.error('Useraccount check failed:', error);

      // Spezifisch auf "not_found" prüfen
      if (error.status === 404 && error.error?.code === 'not_found') {
        // Optional: unterschiedliche Behandlung
        console.warn('Benutzer hat keinen Account');
      } else {
        return of(router.createUrlTree(['/backend-offline'])); // Redirect to backend offline page
        //Backend offline oder andere Fehler
      }

      // Bei Fehler auf noLicense umleiten
      return of(router.createUrlTree(['/createAccount']));
    })
  );
};
